/**
 * Function to use with RTK Query **providesTags** inside *EndpointBuilder* query.
 * Used to simplify list update routine.
 *
 * @param resultsWithIds
 * @param tagType
 * @param idFieldName
 * @returns
 */
// function providesList<R extends Item[], T extends string, Item>(
// 	resultsWithIds: R | undefined,
// 	tagType: T,
// 	// idFieldName: keyof Item & string = 'id' as keyof Item & string satisfies keyof Item
// 	// TODO: still not working - still allows to miss the parameter (undefined) even if Item doesn't have 'id' in fields.
// 	idFieldName: keyof Item & string = 'id' as keyof Item & string
// ) {
// 	return resultsWithIds
// 		? [{ type: tagType, id: 'LIST' }, ...resultsWithIds.map((item) => ({ type: tagType, id: item[idFieldName ?? 'id'] }))]
// 		: [{ type: tagType, id: 'LIST' }];
// }
function providesList(resultsWithIds, tagType, idFieldName) {
    return resultsWithIds
        ? [
            { type: tagType, id: 'LIST' },
            ...resultsWithIds.map((item) => ({ type: tagType, id: item[idFieldName ?? 'id'] })),
        ]
        : [{ type: tagType, id: 'LIST' }];
}
export { providesList };
